/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 根据中分位id获取中分位 的 **请求配置**
 *
 * @分类 旧接口文档/开发波次单越库限制条件
 * @请求头 `POST /erp/HalveGroup/getHgCodeByHgId`
 */
const postGetHgCodeByHgIdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/HalveGroup/getHgCodeByHgId",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetHgCodeByHgId",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 根据中分位id获取中分位 的 **请求函数**
 *
 * @分类 旧接口文档/开发波次单越库限制条件
 * @请求头 `POST /erp/HalveGroup/getHgCodeByHgId`
 */
export const postGetHgCodeByHgId = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetHgCodeByHgIdRequestConfig, requestData),
    ...args
  );
};
postGetHgCodeByHgId.requestConfig = postGetHgCodeByHgIdRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 获取可用的中分位分组信息 的 **请求配置**
 *
 * @分类 仓储API/中分位
 * @请求头 `POST /erp/HalveGroup/getHalveGroupData`
 */
const postGetHalveGroupDataRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/HalveGroup/getHalveGroupData",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetHalveGroupData",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取可用的中分位分组信息 的 **请求函数**
 *
 * @分类 仓储API/中分位
 * @请求头 `POST /erp/HalveGroup/getHalveGroupData`
 */
export const postGetHalveGroupData = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetHalveGroupDataRequestConfig, requestData),
    ...args
  );
};
postGetHalveGroupData.requestConfig = postGetHalveGroupDataRequestConfig;
/**
 * 接口 获取可用的中分位信息 的 **请求配置**
 *
 * @分类 仓储API/中分位
 * @请求头 `POST /erp/HalveGroup/getHalveGroupDetailData`
 */
const postGetHalveGroupDetailDataRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/HalveGroup/getHalveGroupDetailData",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetHalveGroupDetailData",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取可用的中分位信息 的 **请求函数**
 *
 * @分类 仓储API/中分位
 * @请求头 `POST /erp/HalveGroup/getHalveGroupDetailData`
 */
export const postGetHalveGroupDetailData = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetHalveGroupDetailDataRequestConfig, requestData),
    ...args
  );
};
postGetHalveGroupDetailData.requestConfig =
  postGetHalveGroupDetailDataRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/halveGroup.js